import React from 'react';

export default ({ children }) => (
  <div className="content-section-person-container">
    <div className="content-section-header">{children}</div>
  </div>
);
